export interface VideoSource {
   videos?: string[] | null
   videoId?: string | null
}

export const buildLegacyYoutubeUrl = (videoId?: string | null) =>
   videoId ? `https://www.youtube.com/watch?v=${videoId}` : null

export const normalizeInitialVideos = (source?: VideoSource | null) => {
   const videos = source?.videos
   if (Array.isArray(videos)) return videos

   const legacyYoutubeUrl = buildLegacyYoutubeUrl(source?.videoId ?? null)
   return legacyYoutubeUrl ? [legacyYoutubeUrl] : []
}
